import React from 'react';
import styled from 'styled-components';
export function Switch({ enabled, onClick, className }) {
    return (React.createElement(StyledSwitch, { className: className, enabled: enabled, onClick: onClick },
        React.createElement(Switcher, null)));
}
export function Switcher() {
    return React.createElement(StyledSwitcher, null);
}
const StyledSwitch = styled.div `
  cursor: pointer;
  width: 60px;
  height: 32px;
  border-radius: 50px;
  background-color: #ccc;
  position: relative;
  display: inline-flex;
  align-items: center;
  ${(props) => props.enabled &&
    `
    background-color: hsla(87, 59%, 49%, .8);
    & div {
      right: 2px;
      left: auto;
    }
  `}
`;
const StyledSwitcher = styled.div `
  position: absolute;
  left: 2px;
  width: 28px;
  height: 28px;
  border-radius: 50px;
  background-color: white;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
`;
export default Switch;
